import Vue from 'vue';
import axios from 'axios';
import '../../../../filters';
import moment from 'moment';
import { FormWizard, TabContent } from 'vue-form-wizard';
import debounce from "lodash.debounce";

import { validationMixin } from 'vuelidate';
import {
  required,
  email,
  minLength,
  maxLength,
  between
} from 'vuelidate/lib/validators';

export default {
  name: 'CaptureConnection',
  mixins: [validationMixin],
  components: {
    FormWizard,
    TabContent,
    selectConnectionComp: require('../../../selectConnectionComp/selectConnectionComp.vue').default,
  },
  props: ['dataObj'],
  data: function () {
    return {
      appId: -1,
      sewerConnectionsCols: [],
      sewerConnectionsKeyColumn: 'connectionId',

      connectionDate2: null,
      expiryDate: null,
      surveyDate2: null,

      showSelectConnection: false,
      selectConnectionDataObj: {},

      currentTab: 'tab-connectionDetails'
    }
  },
  validations: {
    dataObj: {
      connectionDetailsData: {
        numberOfFlats: {
          required,
          between: between(1, 500)
        }
      }
    }
  },
  computed: {

  },
  watch: {
    "dataObj.connectionDetailsData.surveyRef": function (val) {
      if (val != '' && val != null)
        this.debouncedSurveyRefNo();
    },
    connectionDate2: function (val) {
      if (val)
        this.dataObj.connectionDetailsData.connectionDate = this.createDate(val);
      else
        this.dataObj.connectionDetailsData.connectionDate = null;
    },
    expiryDate: function (val) {
      if (val)
        this.dataObj.connectionDetailsData.expiryDate = this.createDate(val);
      else
        this.dataObj.connectionDetailsData.expiryDate = null;
    },
    surveyDate2: function (val) {
      if (val)
        this.dataObj.connectionDetailsData.surveyDate = this.createDate(val);
      else
        this.dataObj.connectionDetailsData.surveyDate = null;
    },
  },
  created() {
    //console.log("conn data", this.dataObj)
    this.$material.locale.dateFormat = 'dd/MM/yyyy';
    this.$root.$on('capture_connection_updated', this.init);
    this.debouncedSurveyRefNo = debounce(() => {
      if (this.dataObj.connectionDetailsData.surveyRef > 2147483648 || this.dataObj.connectionDetailsData.surveyRef < -2147483648) {
        this.$alertMsg(this.$t('activities.surveyRefNoError'));
        this.dataObj.connectionDetailsData.surveyRef = null;
        return;
      }
    }, 3000);
    this.fillSewerConnectionsCols();
    this.init();
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.appId = this.dataObj.appId;
        this.$material.locale.dateFormat = 'dd/MM/yyyy';
        this.connectionDate2 = moment(this.dataObj.connectionDetailsData.connectionDate).format('DD/MM/YYYY');
        this.expiryDate = moment(this.dataObj.connectionDetailsData.expiryDate).format('DD/MM/YYYY');
        this.surveyDate2 = moment(this.dataObj.connectionDetailsData.surveyDate).format('DD/MM/YYYY');
      });
    },
    createDate(dte) {
      let dteArr = dte.split('/');
      let date = new Date();

      date.setDate(dteArr[0]);
      date.setMonth(dteArr[1] - 1);
      date.setFullYear(dteArr[2]);

      return moment(date).format()
    },
    selectBulkConnection() {
      this.showSelectConnection = true;
    },
    fillSewerConnectionsCols() {
      this.sewerConnectionsCols.push({ dataField: 'connNo', caption: this.$t('activities.connNo') });
      this.sewerConnectionsCols.push({ dataField: 'connectionDate', caption: this.$t('activities.connectionDate'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });
      this.sewerConnectionsCols.push({ dataField: 'estimatedConsumption', caption: this.$t('activities.estimatedConsumption') });
    },
    selectConnectionDone(info) {
      this.dataObj.bulkConnectionReference = info.connection;
      this.dataObj.bulkConnectionNumber = info.connectionNumber;
      this.dataObj.bulkConnectionId = info.connectionId;

      this.dataObj.connectionDetailsData.bulkConnectionReference = info.connection;
      this.dataObj.connectionDetailsData.bulkConnectionNumber = info.connectionNumber;
      this.dataObj.connectionDetailsData.bulkConnectionId = info.connectionId;

      this.showSelectConnection = false;
    },

    getValidationClass(data, objName, fieldName) {
      const field = this.$v[data][objName][fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    },

    validateAppData() {
      if (this.dataObj.connectionDetailsData.connectionType == 1 && (this.dataObj.connectionDetailsData.bulkConnectionId < 0 ||
        this.dataObj.connectionDetailsData.bulkConnectionReference == '' || this.dataObj.connectionDetailsData.bulkConnectionNumber == '' || this.dataObj.connectionDetailsData.bulkConnectionId == '' ||
        this.dataObj.connectionDetailsData.bulkConnectionReference == null || this.dataObj.connectionDetailsData.bulkConnectionNumber == null || this.dataObj.connectionDetailsData.bulkConnectionId == null)) {
        this.$alertMsg(this.$t('bulkConnectionNotSelected'));
      }

      this.$v.$touch();

      if (this.$v.$invalid) {
        this.currentTab = 'tab-connectionDetails';
      }

      if (!this.$v.$invalid) {
        return true;
      }
      else {
        return false;
      }
    },
    changeTab(e) {
      this.currentTab = e;
    },
    getCoordinates() {
      navigator.geolocation.getCurrentPosition((position) => {
        var lat = position.coords.latitude;
        var lng = position.coords.longitude;
        var alti = position.coords.altitude;

        if (lat != null && lng != null) {
          this.dataObj.coordinatesData.y = lat;
          this.dataObj.coordinatesData.x = lng;
          this.dataObj.coordinatesData.z = alti;
          this.dataObj.coordinatesData.gpsAccuracy = position.coords.accuracy != null ? position.coords.accuracy.toFixed(1) : '';
          this.dataObj.coordinatesData.ygps = lat;
          this.dataObj.coordinatesData.xgps = lng;
          this.dataObj.coordinatesData.zgps = alti;
          this.dataObj.coordinatesData.accuracy = position.coords.accuracy != null ? position.coords.accuracy.toFixed(1) : '';
        }
      });
    },
  },
  
}

